const mapStateToProps = (state) => {
    const {
        // ui: {
        //     selectedGeoObjArray,
        //     rangeStartDate,
        //     rangeEndDate,
        // } = {},
        api: {
            geoMultiObjReportExcel,
        } = {},
        // service: {
        //     Api: {
        //         getMultiGeoObjReportExcel,
        //     } = {}
        // } = {}
    } = state;
    return {
        // selectedGeoObjArray,
        // rangeStartDate,
        // rangeEndDate,
        // getMultiGeoObjReportExcel,
        geoMultiObjReportExcel,
    }
}

export default mapStateToProps